import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// -----------------------------------------------------------
//  MobileDeliveryOptionFilter
// -----------------------------------------------------------
const MobileDeliveryOptionFilter = ({ optionkey, title, onToggle, selected, available }) => {
  const [isSelected, setIsSelected] = useState(selected);
  useEffect(() => {setIsSelected(selected) }, [selected])

  const handleClick = (event) => {
    event.preventDefault();
    onToggle(optionkey);
    setIsSelected(!isSelected)
  };

  return (
      <li className="options-list-names mb-1">
        <div
          className={classNames(
            'no-capitalize text-unstyled d-flex',
            {
              selected: selected,
              disabled: !available,
            }
          )}
        >
          <input type="radio"
            id={title}
            className={classNames(
              'mr-2 black-radio-button',
              {
                selected: selected,
                disabled: !available,
              }
            )}
            onChange={handleClick}
            checked={selected}
            aria-label={title}>
          </input>
          <label htmlFor={title} className='m-0'>
            {title}
          </label>
        </div>
      </li>
  );
};

MobileDeliveryOptionFilter.propTypes = {
  optionkey: PropTypes.number,
  title: PropTypes.string,
  onToggle: PropTypes.func,
  selected: PropTypes.bool,
  available: PropTypes.bool,
};

export default MobileDeliveryOptionFilter;
